import { render, staticRenderFns } from "./ReviewCarousel.vue?vue&type=template&id=cf9d8e52&scoped=true"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js"
import style0 from "./ReviewCarousel.vue?vue&type=style&index=0&id=cf9d8e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d8e52",
  null
  
)

export default component.exports